/* eslint-disable no-underscore-dangle */
import classnames from 'classnames';
import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import { Typography } from '@material-ui/core';

import Loader from 'Elements/Loader';
import {
  withMeetingContext,
  MeetingAVInputStates,
  MeetingContextMeetingControlsProps,
  MeetingContextDeviceControlsProps,
  MeetingContextAVControlsProps,
} from 'Scenes/_root/meetingContext';
import withDeviceOrientation from 'Services/withDeviceOrientation';
import MeetingFeedback from './MeetingFeedback';
import MediaControls from './MediaControls';
import styles from './styles.scss';

class MeetingActive extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    const {
      avControls,
      deviceControls,
      registerMeetingCallbacks,
    } = props;
    this.localVideoTile = React.createRef();
    this.remoteVideoTile = React.createRef();
    this.localAudioOut = React.createRef();
    this.deregisterMeetingCallbacks = registerMeetingCallbacks('meetingActive', {
      onSelectedVideoDeviceIdUpdated: this.onSelectedVideoDeviceIdUpdated,
      onMeetingVideoAvailabilityUpdated: this.onMeetingVideoAvailabilityUpdated,
      onAttendeeMicrophoneUpdated: this.onAttendeeMicrophoneUpdated,
      onLocalMuteUpdated: this.onLocalMuteUpdated,
      onMeetingVideoTileUpdated: this.onMeetingVideoTileUpdated,
      onRemoteAttendeePresenceUpdated: this.onRemoteAttendeePresenceUpdated,
    });
    const { audioIn, video } = avControls.getState();
    this.state = {
      isLocalMuted: audioIn !== MeetingAVInputStates.ON,
      hasLocalVideo: video === MeetingAVInputStates.ON,
      hasInitialVideoDevice: deviceControls.getSelectedDeviceIds().video !== null,
      isRemoteMuted: true,
      isRemotePresent: false,
      hasRemoteVideo: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const {
      meetingControls,
    } = this.props;
    window.setTimeout(() => {
      meetingControls.join(this.localAudioOut.current);
    }, 0);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.deregisterMeetingCallbacks();
  }

  onRemoteAttendeePresenceUpdated = (chimeAttendeeId, isPresent) => {
    this.setState({
      isRemotePresent: isPresent,
    });
  }

  onLocalMuteUpdated = (isMuted) => {
    this.setState({
      isLocalMuted: isMuted,
    });
  }

  onMeetingVideoTileUpdated = (bindVideoElement, tileState) => {
    const { active, tileId, localTile } = tileState;
    if (localTile) {
      bindVideoElement(tileId, this.localVideoTile.current);
      this.setState({
        hasLocalVideo: active,
        hasInitialVideoDevice: false,
      });
    } else {
      bindVideoElement(tileId, this.remoteVideoTile.current);
    }
  }

  onAttendeeMicrophoneUpdated = (chimeAttendeeId, isRemoteMuted) => {
    this.setState({
      isRemoteMuted,
    });
  };

  onMeetingVideoAvailabilityUpdated = (videoAvailability) => {
    const { remoteVideoAvailable } = videoAvailability;
    this.setState({
      hasRemoteVideo: remoteVideoAvailable,
    });
  }

  renderAVDisplay = (hasVideoOutput, hasInitialVideoDevice, hasAudioOutput, isRemotePresent) => {
    if (!isRemotePresent) {
      return (
        <Typography variant='body1'>Awaiting other attendee...</Typography>
      );
    }
    if (!hasVideoOutput && !hasAudioOutput) {
      return (
        <Typography variant='body1'>No signal</Typography>
      );
    } else if (!hasVideoOutput && !hasInitialVideoDevice && hasAudioOutput) {
      return (
        <Typography variant='body1'>Audio only</Typography>
      );
    }
    return <Loader size={24} />;
  }

  render() {
    const {
      isPortrait,
    } = this.props;
    const {
      isLocalMuted,
      hasLocalVideo,
      hasInitialVideoDevice,
      isRemoteMuted,
      isRemotePresent,
      hasRemoteVideo,
    } = this.state;

    return (
      <div className={styles.videoWrapper}>
        <div className={classnames(styles.local, isPortrait && styles.localPortrait)}>
          <div className={styles.localInner}>
            <div className={styles.noVideo}>
              {this.renderAVDisplay(hasLocalVideo, hasInitialVideoDevice, !isLocalMuted, true)}
            </div>
            <video ref={this.localVideoTile} className={styles.videoWidth} id='localVideo' playsInline />
          </div>
        </div>
        <MeetingFeedback />
        <MediaControls
          audioOutElement={this.localAudioOut.current}
          isPortrait={isPortrait}
          localVideoElement={this.localVideoTile.current}
        />
        <div className={styles.remoteVideo}>
          <div className={styles.noVideo}>
            {this.renderAVDisplay(hasRemoteVideo, false, !isRemoteMuted, hasRemoteVideo || isRemotePresent)}
          </div>
          <video ref={this.remoteVideoTile} className={styles.videoWidth} id='remoteVideo' playsInline />
        </div>
        <audio ref={this.localAudioOut} id='localAudioOut' />
      </div>
    );
  }
}

MeetingActive.propTypes = {
  avControls: MeetingContextAVControlsProps,
  meetingControls: MeetingContextMeetingControlsProps,
  deviceControls: MeetingContextDeviceControlsProps,
  isPortrait: bool.isRequired,
  registerMeetingCallbacks: func.isRequired,
};

export default withMeetingContext([
  'avControls',
  'deviceControls',
  'meetingControls',
  'registerMeetingCallbacks',
])(withDeviceOrientation(MeetingActive));
